// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4116":"054e5481","6633":"3e1cfa8b","7258":"559c844a"}[chunkId] + ".css";
};